// test1777
(1777 && 0);
